import { Dayjs } from "dayjs";
import { TransactionListParams } from "../../services";

/** The การขาย list's filter row, as its fields hold the values. */
export interface SalesListFilters {
  dateFrom: Dayjs;
  dateTo: Dayjs;
  /** สาขา, held as the branch's company_id (head office only). */
  companyId: string;
  routeCode: string;
  transactionNo: string;
  status: string;
  paymentType: string;
  taxId: string;
  customerName: string;
  customerCode: string;
  replaceFlagged: boolean;
}

/** The list API's query apart from paging. */
export type TransactionListFilter = Omit<TransactionListParams, "page" | "limit">;

const API_DATE_FORMAT = "YYYY-MM-DD";

/** The bill number column is varchar(25); the API rejects anything longer. */
export const BILL_NUMBER_MAX_LENGTH = 25;

/**
 * Bill numbers read `PP BB RR NNNNNN`: document type, branch, route, running number. Six
 * characters narrow the search to one route's bills, which is selective enough to run across
 * every date. A shorter prefix would scan millions of bills, so it stays within the picked dates.
 */
export const ALL_DATES_MIN_BILL_NUMBER_LENGTH = 6;

/**
 * Whether the bill number is searched across every date, which is how a bill is found when its
 * date is not known. While it is, the request leaves the date range out and the filter row
 * disables its range picker. Both ask here, so they cannot disagree. A shorter bill number still
 * narrows the list, but only within the picked dates.
 */
export const isBillNumberSearch = (transactionNo: string): boolean =>
  transactionNo.trim().length >= ALL_DATES_MIN_BILL_NUMBER_LENGTH;

export const toTransactionListFilter = (
  filters: SalesListFilters,
): TransactionListFilter => {
  const transactionNo = filters.transactionNo.trim();
  return {
    status: filters.status,
    paymentType: filters.paymentType,
    transaction_date: isBillNumberSearch(transactionNo)
      ? undefined
      : `${filters.dateFrom.format(API_DATE_FORMAT)},${filters.dateTo.format(API_DATE_FORMAT)}`,
    transactionNo,
    companyId: filters.companyId,
    routeCode: filters.routeCode,
    taxId: filters.taxId,
    customerName: filters.customerName,
    customerCode: filters.customerCode,
    replaceFlagged: filters.replaceFlagged,
  };
};
